<template>
    <v-card class="mt-4">
        <v-card-title>
            <app-title>Actualización de Correo</app-title>
        </v-card-title>
        <v-card-text>
            <v-layout>
                <v-flex>
                    <label for="">Correo Actual:</label>
                    {{ !!user && !!user.email? user.email: 'Sin Correo' }}
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-text-field
                        v-model="email"
                        color="primary"
                        type="email"
                        @input="$v.email.$touch()"
                        :error-messages="emailErrors"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-btn color="primary" @click="confirm" :disabled="inProgress" block type="email" name="email" id="email">Actualizar Correo</v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators';
export default {
    data: () => ({
        email: ''
    }),
    validations: {
        email: { required, email}
    },
    computed: {
        emailErrors() {
            const errors = [];
            !this.$v.email.required && errors.push('El campo es requerido');
            !this.$v.email.email && errors.push('Debe ser un correo electrónico válido');
            return errors;
        }
    },
    methods: {
        confirm() {
            this.$v.$touch();
            if(this.$v.$invalid) return;

            this.$emit('confirm', this.email);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/MyAccount/ChangeEmail/ChangeEmail.vue